import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { ValuePair } from '../../../../interfaces/ValuePair';

@Component({
  selector: 'ls-form-multi-select',
  templateUrl: './ls-form-multi-select.component.html'
})
export class LsFormMultiSelectComponent implements OnInit {
  @Input()
  public items: Array<ValuePair> | Observable<Array<ValuePair>>;
  @Input()
  public key: string;
  @Input()
  public multiSelectSearch: boolean;
  @Input()
  public title: string;
  @Input()
  public tooltip: string;
  @Input()
  public value: boolean;
  @Input()
  public form: FormGroup;

  public values: Array<ValuePair>;

  public ngOnInit(): void {
    if (Array.isArray(this.items)) {
      this.values = this.items;
    } else {
      this.items.subscribe((items: Array<ValuePair>) => {
        this.values = items;
      });
    }
  }
}
